<template>
    <div class="px-6 py-4 bg-minplan-beige -mb-4">
        <page-title :title="$t('projects.selectTemplate')"></page-title>
    </div>

    <jet-form-section @submitted="applyTemplate()">
        <template #form>
            <!-- Card Project Template -->
            <form-card
                :title="$t('projects.template')"
                :description="$t('projects.templateDescription')"
            >
                <!-- Plan vorlage-auf-wohnungen (Task 10): Wechsel nur ohne Wohnungen -->
                <div
                    v-if="apartmentCount > 0"
                    class="col-span-6 w-full rounded-md bg-yellow-50 border border-yellow-200 p-3 text-sm text-yellow-800"
                >
                    {{ $t("templateTransfer.switchBlocked") }}
                </div>

                <radio-list v-else v-model="selected" key="uuid" :items="templates" />

                <jet-input-error
                    :message="
                        form.errors.template_uuid ||
                        form.errors['applyTemplate.template_uuid']
                    "
                    class="col-span-6"
                />
            </form-card>
        </template>

        <template #actions>
            <div class="flex justify-end my-4 mx-6">
                <button
                    @click="cancel"
                    type="button"
                    class="inline-block uppercase font-semibold text-xs tracking-widest"
                >
                    {{ $t("actions.cancel") }}
                </button>

                <primary-button
                    v-if="!apartmentCount"
                    :class="{ 'opacity-25': form.processing || !selected }"
                    :disabled="form.processing || !selected"
                    class="ml-3"
                >
                    {{ $t("actions.save") }}
                </primary-button>
            </div>
        </template>
    </jet-form-section>
</template>

<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import FormCard from "@/Shared/Components/FormCard";
import PageTitle from "@/Shared/Components/PageTitle";
import { useForm } from "@inertiajs/inertia-vue3";
import RadioList from "@/Shared/Components/RadioList";

export default defineComponent({
    props: ["project", "templates", "apartmentCount"],
    inheritAttrs: false,
    emits: ["closeModal"],
    layout: MainLayout,
    components: {
        PageTitle,
        FormCard,
        PrimaryButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        RadioList,
    },
    data() {
        return {
            // Die Auswahl hält das ganze Vorlagenobjekt; `form` bekommt nur die UUID,
            // und zwar erst beim Absenden (ein zweiter Versuch nach einem Fehler
            // darf nicht `undefined` senden).
            selected: null,
            form: useForm({
                applyTemplate: {
                    template_uuid: null,
                },
            }),
        };
    },
    methods: {
        cancel() {
            this.$emit("closeModal");
        },
        applyTemplate() {
            this.form
                .transform((data) => ({
                    ...data,
                    applyTemplate: { template_uuid: this.selected?.uuid },
                }))
                .post(
                    this.route("advisors.projects.update", {
                        project: this.project.uuid,
                    }),
                    {
                        preserveScroll: true,
                        onSuccess: () =>
                            this.$notify({
                                group: "success",
                                title: "actions.success",
                                text: "projects.updated",
                            }),
                    }
                );
        },
    },
});
</script>

<style scoped></style>
